/** @jsxImportSource theme-ui */
import { useField } from 'formik';
import React, { forwardRef, useImperativeHandle } from 'react';
import { Input } from 'semantic-ui-react';

import { SemanticFormikProps } from './FormikSemanticProps';

export type FormikSemanticInputRefAttributes = {
  focus: () => void;
  selectAll: () => void;
  focusAndSelectAll: () => void;
};
export const FormikSemanticInput = forwardRef<
  FormikSemanticInputRefAttributes,
  SemanticFormikProps
>(
  (
    {
      name,
      placeholder,
      className,
      error,
      icon,
      maxLength,
      style,
      autoFocus,
      onValueChange,
      onKeyUp,
      onKeyPress,
      onBlur,
      disabled = false,
    },
    ref
  ) => {
    const inputRef = React.useRef<Input>();
    const [field, meta, helpers] = useField(name);
    const { value, onBlur: onBlurFormik } = field;
    const { setValue } = helpers;

    useImperativeHandle(ref, () => ({
      focus: () => inputRef.current && inputRef.current.focus(),
      selectAll: () => inputRef.current && inputRef.current.select(),
      focusAndSelectAll: () => {
        inputRef.current && inputRef.current.select();
        inputRef.current && inputRef.current.focus();
      },
    }));

    const handleOnChange = (val: string | number | boolean | (string | number | boolean)[]) => {
      setValue(val);
      onValueChange && onValueChange(val);
    };

    const handleOnBlur = (e: React.FocusEvent<any>) => {
      onBlur && onBlur();
      onBlurFormik(e);
    };

    return (
      <Input
        ref={inputRef}
        fluid
        autoFocus={autoFocus}
        placeholder={placeholder}
        className={className}
        name={name}
        error={error || !!meta.error}
        icon={icon}
        disabled={disabled}
        maxLength={maxLength}
        style={style}
        onKeyUp={onKeyUp}
        onKeyPress={onKeyPress}
        onChange={(_, { value: v }) => handleOnChange(v)} // TODO: es lint error?
        onBlur={handleOnBlur}
        value={value || ''}
      />
    );
  }
);

export default FormikSemanticInput;
